import { addHeaderInterceptor as t } from "./add-header-interceptor-factory.js";
import { env as r } from "../../envManager.js";
const c = (e) => e.interceptors.request.use(
  t("accept-language", () => r.getLocale())
);
export {
  c as default
};
//# sourceMappingURL=accept-language-interceptor.js.map
